import { queryOptions } from "@tanstack/react-query";
import { FetchCampaignAssigneesResponse } from "@/api/interfaces/responses/campaigns";
import { Campaign } from "@/interfaces/campaign";

export const campaignAssigneesQueryOptions = (id: string) => {
  return queryOptions({
    queryKey: ["campaignAssignees", id] as const,
    queryFn: async () => {
      const response = await fetch(`/api/campaigns/${id}/assignees`);
      if (!response.ok) {
        throw new Error(
          `Failed to fetch campaign assignees for campaign ID ${id}`,
        );
      }

      const data: FetchCampaignAssigneesResponse = await response.json();
      return data;
    },
  });
};

export const fetchCampaignQueryOptions = (id: string | null) => {
  return queryOptions({
    queryKey: ["campaign", id] as const,
    queryFn: async () => {
      const response = await fetch(`/api/campaigns/${id}`);
      if (!response.ok) {
        throw new Error(`Failed to fetch campaign with ID ${id}`);
      }

      const data: Campaign = await response.json();
      return data;
    },
    enabled: Boolean(id),
  });
};
